import { useEffect, useRef } from 'react';

/**
 * useVisibilityPause - Pausa streams quando a aba fica hidden
 *
 * Quando o usuario muda de aba:
 *   - hidden: chama onHidden() com lista de canais ativos
 *   - visible: chama onVisible() com lista de canais que estavam ativos
 *
 * @param {Object} options
 * @param {function} options.onHidden - (channels[]) chamado quando tab fica hidden
 * @param {function} options.onVisible - (channels[]) chamado quando tab volta visible
 * @param {function} options.getActiveChannels - () => Set<number> retorna canais ativos
 */
const useVisibilityPause = ({ onHidden, onVisible, getActiveChannels }) => {
  const savedChannelsRef = useRef(null);
  const onHiddenRef = useRef(onHidden);
  const onVisibleRef = useRef(onVisible);
  const getActiveChannelsRef = useRef(getActiveChannels);
  onHiddenRef.current = onHidden;
  onVisibleRef.current = onVisible;
  getActiveChannelsRef.current = getActiveChannels;

  useEffect(() => {
    const handler = () => {
      if (document.hidden) {
        const active = getActiveChannelsRef.current();
        if (active.size > 0) {
          savedChannelsRef.current = [...active];
          onHiddenRef.current([...active]);
        }
      } else if (savedChannelsRef.current) {
        const channels = savedChannelsRef.current;
        savedChannelsRef.current = null;
        onVisibleRef.current(channels);
      }
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);
};

export default useVisibilityPause;
